export default function yearsAndDays(value) {
    // if value is not a number or a numeric string, return empty string
    if (typeof value !== 'number' && !(typeof value === 'string' && !isNaN(value))) {
        return '';
    }

    let yearString = '',
        dayString = '',
        andString = '',
        days = value % 365,
        years = (value - days) / 365;

    if (years > 0) {
        yearString = years + (years === 1 ? ' year' : ' years');
    }

    if (days > 0) {
        dayString = days + (days === 1 ? ' day' : ' days');
    }

    if (days > 0 && years > 0) {
        andString = ' and ';
    }

    if (years === 0 && days === 0) {
        dayString = days + ' days'
    }

    return yearString + andString + dayString;

}
